/* eslint-disable */
import { Size } from '@/models/core/values';
import { InciList } from '@/models/core/InciList';

const SERUM_USAGES = {
  MORNING_ONLY: 'morningOnly',
  MORNING_AND_EVENING: 'morningAndEvening',
  EVENING_ONLY: 'eveningOnly',
  ONE_MORNING_ONE_EVENING: 'oneMorningOneEvening',
  NO_USAGE: 'noUsage'
};

const FORMULA_USAGE = {
  MORNING_ONLY: 'morningOnly',
  EVENING_ONLY: 'eveningOnly',
  MORNING_AND_EVENING: 'morningAndEvening'
};

const PRODUCT_REFERENCES = {
  ACTIVE_UNIT: 'activeUnit',
  SERUM_UNIT: 'serumUnit',
  SERUM_X2_UNIT: 'serum2Unit',
  NEXULTRA_O: 'nexUltraO',
  NEXULTRA_O1: 'nexUltraO1',
  NEXULTRA_O2: 'nexUltraO2',
  NEXULTRA_1: 'nexUltra1',
  NEXULTRA_2: 'nexUltra2',
  NEXULTRA_3: 'nexUltra3',
  NEXULTRA_B: 'nexUltraB',
  NEXULTRA_B1: 'nexUltraB1',
  NEXULTRA_B2: 'nexUltraB2',
  UNIVERSKIN_H: 'universkinH',
  GEL: 'gel',
  GEL_30: 'gel30',
  GEL_100: 'gel100',
  SUNSCREEN_FLD: 'sunscreenFLD',
  NEXULTRA_L: 'nexUltraL',
  NEXULTRA_L1: 'nexUltraL1',
  SUNSCREEN_SPF: 'sunscreenSPF',
  SUNSCREEN_CRM: 'sunscreenCRM',
  NEXULTRA_UV: 'nexUltraUV',
  NEXULTRA_P_LIGHT: 'nexUltraPLight',
  NEXULTRA_P_RICH: 'nexUltraPRich',
  UNIVERSKIN_M: 'universkinM',
  FREE_SAMPLE: 'freeSample',
  FACE_SERUM: 'faceSerum',
  EYE_CONTOUR_SERUM: 'eyeContourSerum'
};

const SIZE_MEASUREMENT_UNITS = {
  ML: 'ml',
  DOUBLE_ML: 'ml x 2',
  GRAMS: 'g'
};

const PRODUCT_REFERENCE_TO_SIZE_MAP = {
  faceSerum: Size(15, SIZE_MEASUREMENT_UNITS.ML),
  eyeContourSerum: Size(15, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.NEXULTRA_O1]: Size(100, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.NEXULTRA_O2]: Size(200, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.NEXULTRA_1]: Size(40, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.NEXULTRA_2]: Size(40, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.NEXULTRA_3]: Size(40, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.NEXULTRA_B1]: Size(30, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.NEXULTRA_B2]: Size(100, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.UNIVERSKIN_H]: Size(30, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.UNIVERSKIN_M]: Size(150, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.GEL_30]: Size(30, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.GEL_100]: Size(100, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.SUNSCREEN_FLD]: Size(50, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.NEXULTRA_L1]: Size(50, SIZE_MEASUREMENT_UNITS.ML),
  

  [PRODUCT_REFERENCES.SUNSCREEN_SPF]: Size(30, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.SUNSCREEN_CRM]: Size(30, SIZE_MEASUREMENT_UNITS.ML),

  [PRODUCT_REFERENCES.NEXULTRA_UV]: Size(14, SIZE_MEASUREMENT_UNITS.GRAMS),
 
  [PRODUCT_REFERENCES.NEXULTRA_P_LIGHT]: Size(50, SIZE_MEASUREMENT_UNITS.ML),
  [PRODUCT_REFERENCES.NEXULTRA_P_RICH]: Size(50, SIZE_MEASUREMENT_UNITS.ML)
};

const SIZE_MEASUREMENT_UNIT_KEY = {
  [SIZE_MEASUREMENT_UNITS.ML]: 'common.size.ml',
  [SIZE_MEASUREMENT_UNITS.DOUBLE_ML]: 'common.size.doubleML',
  [SIZE_MEASUREMENT_UNITS.GRAMS]: 'common.size.gram'
};

const PRODUCT_USAGE_LABELS_SHORT = {
  [SERUM_USAGES.MORNING_ONLY]: ['AM'],
  [SERUM_USAGES.EVENING_ONLY]: ['PM'],
  [SERUM_USAGES.MORNING_AND_EVENING]: ['AM/PM'],
  [SERUM_USAGES.ONE_MORNING_ONE_EVENING]: ['AM', 'PM']
};

const PRODUCT_NAMES = {
  FACE_SERUM: 'faceSerum',
  EYE_CONTOUR_SERUM: 'eyeContourSerum',
  NEXULTRA_O: PRODUCT_REFERENCES.NEXULTRA_O,
  NEXULTRA_1: PRODUCT_REFERENCES.NEXULTRA_1,
  NEXULTRA_2: PRODUCT_REFERENCES.NEXULTRA_2,
  NEXULTRA_3: PRODUCT_REFERENCES.NEXULTRA_3,
  NEXULTRA_B: PRODUCT_REFERENCES.NEXULTRA_B,
  UNIVERSKIN_H: PRODUCT_REFERENCES.UNIVERSKIN_H,
  GEL: PRODUCT_REFERENCES.GEL,
  NEXULTRA_L: PRODUCT_REFERENCES.NEXULTRA_L,
  SUNSCREEN_SPF: PRODUCT_REFERENCES.SUNSCREEN_SPF,
  SUNSCREEN_FLD: PRODUCT_REFERENCES.SUNSCREEN_FLD,
  SUNSCREEN_CRM: PRODUCT_REFERENCES.SUNSCREEN_CRM,
  NEXULTRA_UV: PRODUCT_REFERENCES.NEXULTRA_UV,
  NEXULTRA_P_LIGHT: PRODUCT_REFERENCES.NEXULTRA_P_LIGHT,
  NEXULTRA_P_RICH: PRODUCT_REFERENCES.NEXULTRA_P_RICH,
  UNIVERSKIN_M: PRODUCT_REFERENCES.UNIVERSKIN_M,
  FREE_SAMPLE: PRODUCT_REFERENCES.FREE_SAMPLE
};

const PRODUCT_LABEL = {
  [PRODUCT_NAMES.FACE_SERUM]: 'product.addToCartNotificationLabel.faceSerum',
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: 'product.addToCartNotificationLabel.eyeContourSerum',
  [PRODUCT_NAMES.NEXULTRA_O]: 'Nexultra O',
  [PRODUCT_NAMES.NEXULTRA_1]: 'Nexultra 1',
  [PRODUCT_NAMES.NEXULTRA_2]: 'Nexultra 2',
  [PRODUCT_NAMES.NEXULTRA_3]: 'Nexultra 3',
  [PRODUCT_NAMES.NEXULTRA_B]: 'Nexultra B',
  [PRODUCT_NAMES.UNIVERSKIN_H]: 'Universkin H',
  [PRODUCT_NAMES.UNIVERSKIN_M]: 'Universkin M',
  [PRODUCT_NAMES.NEXULTRA_L]: 'Nexultra L',
  [PRODUCT_NAMES.GEL]: 'The Gel',
  [PRODUCT_NAMES.SUNSCREEN_SPF]: 'The Serum Sunscreen SPF50+',
  [PRODUCT_NAMES.SUNSCREEN_FLD]: 'The Sunscreen Fluid SPF50',
  [PRODUCT_NAMES.SUNSCREEN_CRM]: 'The Sun Cream SPF50+',
  [PRODUCT_NAMES.NEXULTRA_UV]: 'Nexultra UV',
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: 'Nexultra P Light',
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: 'Nexultra P Rich'
};

const SERUM_PRODUCT_NAMES = [PRODUCT_NAMES.FACE_SERUM, PRODUCT_NAMES.EYE_CONTOUR_SERUM];

const TREATMENT_DURATION_MONTHS = {
  ONE_MONTH: '1',
  ONE_AND_HALF_MONTHS: '1.5',
  TWO_MONTHS: '2',
  THREE_MONTHS: '3',
  FOUR_MONTHS: '4'
};

const TreatmentDurationConfig = new (class {
  constructor() {
    const NEXULTRA_1_2_3_DURATION_CONFIG = {
      [SERUM_USAGES.MORNING_AND_EVENING]: TREATMENT_DURATION_MONTHS.ONE_AND_HALF_MONTHS,
      [SERUM_USAGES.MORNING_ONLY]: TREATMENT_DURATION_MONTHS.THREE_MONTHS,
      [SERUM_USAGES.EVENING_ONLY]: TREATMENT_DURATION_MONTHS.THREE_MONTHS
    };

    const NEXULTRA_P_LIGHT_AND_RICH_DURATION_CONFIG = {
      [SERUM_USAGES.MORNING_AND_EVENING]: TREATMENT_DURATION_MONTHS.ONE_MONTH,
      [SERUM_USAGES.MORNING_ONLY]: TREATMENT_DURATION_MONTHS.TWO_MONTHS,
      [SERUM_USAGES.EVENING_ONLY]: TREATMENT_DURATION_MONTHS.TWO_MONTHS
    };

    this.config = {
      [PRODUCT_NAMES.FACE_SERUM]: {
        [SERUM_USAGES.MORNING_ONLY]: TREATMENT_DURATION_MONTHS.FOUR_MONTHS,
        [SERUM_USAGES.EVENING_ONLY]: TREATMENT_DURATION_MONTHS.FOUR_MONTHS,
        [SERUM_USAGES.ONE_MORNING_ONE_EVENING]: TREATMENT_DURATION_MONTHS.TWO_MONTHS,
        [SERUM_USAGES.MORNING_AND_EVENING]: TREATMENT_DURATION_MONTHS.TWO_MONTHS
      },
      [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: {
        [SERUM_USAGES.MORNING_AND_EVENING]: TREATMENT_DURATION_MONTHS.TWO_MONTHS,
        [SERUM_USAGES.MORNING_ONLY]: TREATMENT_DURATION_MONTHS.FOUR_MONTHS,
        [SERUM_USAGES.EVENING_ONLY]: TREATMENT_DURATION_MONTHS.FOUR_MONTHS
      },
      [PRODUCT_NAMES.UNIVERSKIN_H]: TREATMENT_DURATION_MONTHS.ONE_AND_HALF_MONTHS,
      [PRODUCT_NAMES.UNIVERSKIN_M]: TREATMENT_DURATION_MONTHS.TWO_MONTHS,
      [PRODUCT_NAMES.NEXULTRA_1]: NEXULTRA_1_2_3_DURATION_CONFIG,
      [PRODUCT_NAMES.NEXULTRA_2]: NEXULTRA_1_2_3_DURATION_CONFIG,
      [PRODUCT_NAMES.NEXULTRA_3]: NEXULTRA_1_2_3_DURATION_CONFIG,
      [PRODUCT_NAMES.NEXULTRA_L]: {
        50: TREATMENT_DURATION_MONTHS.TWO_MONTHS
      },
      [PRODUCT_NAMES.NEXULTRA_B]: {
        30: TREATMENT_DURATION_MONTHS.TWO_MONTHS,
        100: TREATMENT_DURATION_MONTHS.FOUR_MONTHS
      },
      [PRODUCT_NAMES.NEXULTRA_O]: {
        100: TREATMENT_DURATION_MONTHS.TWO_MONTHS,
        200: TREATMENT_DURATION_MONTHS.FOUR_MONTHS
      },
      // A rinse-off cleanser is used faster than a balm of the same size, so the gel runs
      // shorter than Nexultra B for the equivalent format.
      [PRODUCT_NAMES.GEL]: {
        30: TREATMENT_DURATION_MONTHS.ONE_MONTH,
        100: TREATMENT_DURATION_MONTHS.THREE_MONTHS
      },
      [PRODUCT_NAMES.SUNSCREEN_SPF]: TREATMENT_DURATION_MONTHS.THREE_MONTHS,
      [PRODUCT_NAMES.SUNSCREEN_CRM]: TREATMENT_DURATION_MONTHS.TWO_MONTHS,
      [PRODUCT_NAMES.SUNSCREEN_FLD]: TREATMENT_DURATION_MONTHS.THREE_MONTHS,
      [PRODUCT_NAMES.NEXULTRA_UV]: TREATMENT_DURATION_MONTHS.THREE_MONTHS,
      [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: NEXULTRA_P_LIGHT_AND_RICH_DURATION_CONFIG,
      [PRODUCT_NAMES.NEXULTRA_P_RICH]: NEXULTRA_P_LIGHT_AND_RICH_DURATION_CONFIG
    };
  }

  getDuration({ productName, usage, size }) {
    return (
      this.config[productName][usage] ||
      this.config[productName][size.value] ||
      this.config[productName]
    );
  }
})();

const SERUM_UNIT_SIZE = { value: 15, units: SIZE_MEASUREMENT_UNITS.ML };

const PRODUCT_SIZE_OPTIONS = {
  [PRODUCT_NAMES.NEXULTRA_B]: [
    { value: 30, units: SIZE_MEASUREMENT_UNITS.ML },
    { value: 100, units: SIZE_MEASUREMENT_UNITS.ML }
  ],
  [PRODUCT_NAMES.NEXULTRA_O]: [
    { value: 100, units: SIZE_MEASUREMENT_UNITS.ML },
    { value: 200, units: SIZE_MEASUREMENT_UNITS.ML }
  ],
  [PRODUCT_NAMES.NEXULTRA_L]: [
    { value: 50, units: SIZE_MEASUREMENT_UNITS.ML }
  ],
  [PRODUCT_NAMES.GEL]: [
    { value: 30, units: SIZE_MEASUREMENT_UNITS.ML },
    { value: 100, units: SIZE_MEASUREMENT_UNITS.ML }
  ]
};

const NEXULTRA_B_DEFAULT_SIZE_OPTION = PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.NEXULTRA_B][0];
const NEXULTRA_L_DEFAULT_SIZE_OPTION = PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.NEXULTRA_L][0];
const NEXULTRA_O_DEFAULT_SIZE_OPTION = PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.NEXULTRA_O][0];
const GEL_DEFAULT_SIZE_OPTION = PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.GEL][0];


const PRODUCT_SIZE = {
  [PRODUCT_NAMES.FACE_SERUM]: SERUM_UNIT_SIZE,
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: SERUM_UNIT_SIZE,
  [PRODUCT_NAMES.NEXULTRA_O]: NEXULTRA_O_DEFAULT_SIZE_OPTION,
  [PRODUCT_NAMES.GEL]: GEL_DEFAULT_SIZE_OPTION,
  [PRODUCT_NAMES.SUNSCREEN_FLD]: {
    value: 50,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.NEXULTRA_1]: {
    value: 40,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.NEXULTRA_2]: {
    value: 40,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.NEXULTRA_3]: {
    value: 40,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.NEXULTRA_B]: NEXULTRA_B_DEFAULT_SIZE_OPTION,
  [PRODUCT_NAMES.NEXULTRA_L]: NEXULTRA_L_DEFAULT_SIZE_OPTION,
  [PRODUCT_NAMES.SUNSCREEN_SPF]: {
    value: 30,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.SUNSCREEN_CRM]: {
    value: 30,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.NEXULTRA_UV]: {
    value: 14,
    units: SIZE_MEASUREMENT_UNITS.GRAMS
  },
  [PRODUCT_NAMES.UNIVERSKIN_H]: {
    value: 30,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: {
    value: 50,
    units: SIZE_MEASUREMENT_UNITS.ML
  },
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: {
    value: 50,
    units: SIZE_MEASUREMENT_UNITS.ML
  }
};

const PRODUCTS = {
  [PRODUCT_NAMES.FACE_SERUM]: {
    usage: SERUM_USAGES.ONE_MORNING_ONE_EVENING,
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.FACE_SERUM]
  },
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: {
    usage: SERUM_USAGES.MORNING_AND_EVENING,
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.FACE_SERUM]
  },
  [PRODUCT_NAMES.NEXULTRA_O]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_O],
    sizeOptions: PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.NEXULTRA_O]
  },
  [PRODUCT_NAMES.UNIVERSKIN_H]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.UNIVERSKIN_H]
  },
  [PRODUCT_NAMES.UNIVERSKIN_M]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.UNIVERSKIN_H]
  },
  [PRODUCT_NAMES.NEXULTRA_1]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_1]
  },
  [PRODUCT_NAMES.NEXULTRA_2]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_2]
  },
  [PRODUCT_NAMES.NEXULTRA_3]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_3]
  },
  [PRODUCT_NAMES.NEXULTRA_L]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_L],
    sizeOptions: PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.NEXULTRA_L]
  },
  [PRODUCT_NAMES.NEXULTRA_B]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_B],
    sizeOptions: PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.NEXULTRA_B]
  },
  [PRODUCT_NAMES.GEL]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.GEL],
    sizeOptions: PRODUCT_SIZE_OPTIONS[PRODUCT_NAMES.GEL]
  },
  [PRODUCT_NAMES.SUNSCREEN_SPF]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.SUNSCREEN_SPF]
  },
  [PRODUCT_NAMES.SUNSCREEN_FLD]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.SUNSCREEN_FLD]
  },
  [PRODUCT_NAMES.SUNSCREEN_CRM]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.SUNSCREEN_CRM]
  },
  [PRODUCT_NAMES.NEXULTRA_UV]: {
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_UV]
  },
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: {
    isNew: true,
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_P_LIGHT]
  },
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: {
    isNew: true,
    isRecommended: false,
    size: PRODUCT_SIZE[PRODUCT_NAMES.NEXULTRA_P_RICH]
  }
};

const DEFAULT_TREAT_SECTION_TREATMENT = {
  isRecommended: false,
  formulasOptions: {
    twoFormulas: { isFound: false },
    oneFormula: { isFound: false }
  }
};

const PRODUCT_CATEGORY = {
  CLEANSE: 'cleanse',
  TREAT: 'treat',
  MOISTURIZE: 'moisturize',
  PROTECT: 'protect'
};

const PRODUCT_CATEGORY_LABEL = {
  [PRODUCT_CATEGORY.CLEANSE]: 'product.cleanseMessage',
  [PRODUCT_CATEGORY.TREAT]: 'product.treatMessage',
  [PRODUCT_CATEGORY.MOISTURIZE]: 'product.moisturizeMessage',
  [PRODUCT_CATEGORY.PROTECT]: 'product.protectMessage'
};

const EYE_SERUM_GENERIC_FORMULA = {
  WRINKLES_1: 'WRINKLES_1',
  WRINKLES_2: 'WRINKLES_2',
  WRINKLES_3: 'WRINKLES_3',
  WRINKLES_4: 'WRINKLES_4',
  SWOLLEN_1: 'SWOLLEN_1',
  SWOLLEN_2: 'SWOLLEN_2',
  DARK_CIRCLES_1: 'DARK_CIRCLES_1',
  DARK_CIRCLES_2: 'DARK_CIRCLES_2',
  DARK_CIRCLES_3: 'DARK_CIRCLES_3'
};

const EYE_SERUM_GENERIC_FORMULA_LABELS = {
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_1]: 'section.eyeContourSerum.generic.formulaLabel.wrinkles',
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_2]: 'section.eyeContourSerum.generic.formulaLabel.wrinkles',
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_3]: 'section.eyeContourSerum.generic.formulaLabel.wrinkles',
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_4]: 'section.eyeContourSerum.generic.formulaLabel.wrinkles',
  [EYE_SERUM_GENERIC_FORMULA.SWOLLEN_1]: 'section.eyeContourSerum.generic.formulaLabel.swollen',
  [EYE_SERUM_GENERIC_FORMULA.SWOLLEN_2]: 'section.eyeContourSerum.generic.formulaLabel.swollen',
  [EYE_SERUM_GENERIC_FORMULA.DARK_CIRCLES_1]:
    'section.eyeContourSerum.generic.formulaLabel.darkCircles',
  [EYE_SERUM_GENERIC_FORMULA.DARK_CIRCLES_2]:
    'section.eyeContourSerum.generic.formulaLabel.darkCircles',
  [EYE_SERUM_GENERIC_FORMULA.DARK_CIRCLES_3]:
    'section.eyeContourSerum.generic.formulaLabel.darkCircles'
};

const EYE_SERUM_GENERIC_FORMULA_DESCRIPTIONS = {
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_1]: 'section.eyeContourSerum.generic.description.wrinkles_1',
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_2]: 'section.eyeContourSerum.generic.description.wrinkles_2',
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_3]: 'section.eyeContourSerum.generic.description.wrinkles_3',
  [EYE_SERUM_GENERIC_FORMULA.WRINKLES_4]: 'section.eyeContourSerum.generic.description.wrinkles_4',
  [EYE_SERUM_GENERIC_FORMULA.SWOLLEN_1]: 'section.eyeContourSerum.generic.description.swollen_1',
  [EYE_SERUM_GENERIC_FORMULA.SWOLLEN_2]: 'section.eyeContourSerum.generic.description.swollen_2',
  [EYE_SERUM_GENERIC_FORMULA.DARK_CIRCLES_1]:
    'section.eyeContourSerum.generic.description.dark_circles_1',
  [EYE_SERUM_GENERIC_FORMULA.DARK_CIRCLES_2]:
    'section.eyeContourSerum.generic.description.dark_circles_2',
  [EYE_SERUM_GENERIC_FORMULA.DARK_CIRCLES_3]:
    'section.eyeContourSerum.generic.description.dark_circles_3'
};

const PRODUCT_NAME_TO_CATEGORIES_LIST_MAP = {
  [PRODUCT_NAMES.FACE_SERUM]: [PRODUCT_CATEGORY.TREAT],
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: [PRODUCT_CATEGORY.TREAT],
  [PRODUCT_NAMES.UNIVERSKIN_H]: [PRODUCT_CATEGORY.TREAT, PRODUCT_CATEGORY.MOISTURIZE],

  [PRODUCT_NAMES.NEXULTRA_O]: [PRODUCT_CATEGORY.CLEANSE],
  [PRODUCT_NAMES.GEL]: [PRODUCT_CATEGORY.CLEANSE],
  [PRODUCT_NAMES.FREE_SAMPLE]: [PRODUCT_CATEGORY.CLEANSE],

  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: [PRODUCT_CATEGORY.MOISTURIZE],
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: [PRODUCT_CATEGORY.MOISTURIZE],
  [PRODUCT_NAMES.NEXULTRA_B]: [PRODUCT_CATEGORY.MOISTURIZE],
  [PRODUCT_NAMES.NEXULTRA_L]: [PRODUCT_CATEGORY.MOISTURIZE, PRODUCT_CATEGORY.PROTECT],
  [PRODUCT_NAMES.NEXULTRA_1]: [PRODUCT_CATEGORY.MOISTURIZE],
  [PRODUCT_NAMES.NEXULTRA_2]: [PRODUCT_CATEGORY.MOISTURIZE],
  [PRODUCT_NAMES.NEXULTRA_3]: [PRODUCT_CATEGORY.MOISTURIZE],
  [PRODUCT_NAMES.SUNSCREEN_SPF]: [PRODUCT_CATEGORY.PROTECT],
  [PRODUCT_NAMES.SUNSCREEN_CRM]: [PRODUCT_CATEGORY.PROTECT],
  [PRODUCT_NAMES.SUNSCREEN_FLD]: [PRODUCT_CATEGORY.PROTECT],
  [PRODUCT_NAMES.NEXULTRA_UV]: [PRODUCT_CATEGORY.PROTECT],
  [PRODUCT_NAMES.UNIVERSKIN_M]: [PRODUCT_CATEGORY.PROTECT]
};

const COMPLEMENTARY_PRODUCT_INCI_LIST = {
  [PRODUCT_NAMES.GEL]: InciList(null, null, [
    'Aqua (Water)',
    'Decyl Glucoside',
    'Mandelic Acid',
    'Sodium Hydroxide',
    'Lactic Acid',
    'Glycerin',
    'Sodium Lauroyl Sarcosinate',
    'Gluconolactone',
    'Salicylic Acid',
    'Succinic Acid',
    'Tartaric Acid',
    'Xanthan Gum',
    'Parfum (Fragrance)',
    'Sodium Benzoate',
    'Potassium Sorbate',
    'Sodium Phytate'
  ]),
  [PRODUCT_NAMES.SUNSCREEN_FLD]: InciList(null, null, [
    'Zinc Oxide',
    'Water',
    'Dimethicone',
    'Isopropyl Myristate',
    'C13-15 Alkane',
    'Glycerin',
    'Butyloctyl Salicylate',
    'Silica',
    'Polyhydroxystearic Acid',
    'Cetyl Diglyceryl Tris(Trimethylsiloxy)silylethyl Dimethicone',
    'Tripeptide-1',
    'Aloe Barbadensis Leaf Juice',
    'Sodium Chloride',
    'Sorbitan Olivate',
    'Pentylene Glycol',
    'CI 77941 (Iron Oxides)',
    'Caprylyl Glycol',
    'Synthetic Beeswax',
    'Propanediol',
    'C12-15 Alkyl Benzoate',
    'Ethylhexylglycerin',
    'Sodium Phytate',
    'Hydrogen Dimethicone',
    'Dextran',
    'Hydrogenated Lecithin'
  ]),
  [PRODUCT_NAMES.NEXULTRA_O]: InciList(null, null, [
    'Olea Europapea (Olive)',
    'Fruit Oil',
    'PEG-20',
    'Glyceryl Triisostearate',
    'Caprylic/Capric Triglyceride',
    'Pentylene Glycol',
    'Camelina Sativa Seed Oil',
    'Tocopherol',
    'Helianthus Annuus (Sunflower) Seed Oil',
    'Glycine Soja (Soybean) Oil',
    'Rosmarinus Officinalis (Rosemary) Leaf Extract',
    'Chamomilla Recutita (Matricaria) Flower Extract',
    'Glycerin',
    'Aqua (Water)',
    'Dextrain',
    'Tripeptide-1'
  ]),
  [PRODUCT_NAMES.NEXULTRA_1]: InciList(null, null, [
    'Aqua (Water)',
    'Dicaprylyl Carbonate',
    'Propanediol',
    'Camelina Sativa Seed Oil',
    'Glycerin',
    'Cetyl Alcohol',
    'Glyceryl Stearate',
    '1,2-hexanediol',
    'Caprylyl Glycol',
    'Ceteth-20',
    'Steareth-20',
    'Dimethicone Crosspolymer',
    'Tocopheryl Acetate',
    'Xantham Gum',
    'Aloe Barbadensis Leaf Juice Powder',
    'Sodium Hydroxide',
    'Citric Acid',
    'Tannic Acid',
    'Potassium Sorbate',
    'Tocopherol',
    'Helianthus Annuuss Seed Oil',
    'Dextran',
    'Tripeptide-1'
  ]),
  [PRODUCT_NAMES.NEXULTRA_2]: InciList(null, null, [
    'Aqua (Water)',
    'Dycaprylyl Carbonate',
    'Camelina Sativa Seed Oil',
    'Dimethicone',
    'Glycerin',
    'Cetyl Alcohol',
    'Glyecryl Stearate',
    'Microcrystalline Cellulose',
    'PEG-75 Stearate',
    'Phenoxyethanol',
    'Ceteth-20',
    'Steareth-20',
    'Parfum (Fragarance)',
    'Caprylyl Glycol',
    'Cellulose Gum',
    'Chlorphenesin',
    'Tocopheryl Acetate',
    'Xantham Gum',
    'Aloe Barbadensis Leaf Juice Powder',
    'Tocopherol',
    'Dextran',
    'Acetyl Hexapeptide-1',
    'TrifluoroAcetyl Tripeptide-2'
  ]),
  [PRODUCT_NAMES.NEXULTRA_3]: InciList(null, null, [
    'Aqua (Water)',
    'Dicaprylyl Carbonate',
    'Camelina Sativa Seed Oil',
    'Glyceryn',
    'Candelilla/Jojoba/Rice Bran Polyglyceryl-3',
    'Esters',
    'Glyceryl Stearate',
    'Cetyl Alcohol',
    'Dimethicone',
    'Microcrystalline Cellulose',
    'Hydrogenated Camelina Sativa Seed Oil',
    'Cetearyl Alcohol',
    'Sodium Stearoyl Lactylate',
    'Phenoxyethanol',
    'Caprylyl Glycol',
    'Parfum (Fragarance)',
    'Cellulose Gum',
    'Chlorphenesin',
    'Tocopheryl Acetate',
    'Xantham Gum',
    'Aloe Barbadensis Leaf Juice Powder',
    'Tocopherol',
    'Dextran',
    'Acetyl Tetrapeptide-2',
    'TrifluoroAcetyl Tripeptide-2'
  ]),
  [PRODUCT_NAMES.NEXULTRA_B]: InciList(null, null, [
    'Dicaprylyl Carbonate',
    'Hydroxystearic/Linolenic/Oleic Polyglycerides',
    'Tapioca Starch',
    'Stearalkonium Hectorite',
    'Camelina Sativa Seed Oil',
    'Helianthus Annuus(Sunflower)seed Oil',
    'Propylene Carbonate',
    'Aqua(Water)',
    'Hydrogenated Camelina Sativa Seed Oil',
    'CI 77891 (Titanium Dioxide)',
    'Polymethylsilsesquioxane',
    'Ricinus Communis (Castor) Seed Oil',
    'Glycerin',
    'Aloe Barbadensis Extract',
    'Bisabolol',
    'Tocopheryl Acetate',
    'Dextran',
    'Tripeptide-1',
    'Tocopherol'
  ]),
  [PRODUCT_NAMES.UNIVERSKIN_H]: InciList(null, null, [
    'Aqua (Water)',
    'Alcohol Denat.',
    'Camelina Sativa Seed Oil',
    'Glycerin',
    'Sodium Acrylate/Sodium Acryloyldimethyl Taurate Copolymer',
    'Parfum (Fragrance)',
    'Isohexadecane',
    '1,2-hexanediol',
    'Caprylyl Glycol',
    'Xanthan Gum',
    'Sodium Hyaluronate',
    'Sodium Phytate',
    'Polysorbate 80',
    'EDTA',
    'Potassium Sorbate',
    'Sorbitan Oleate',
    'Sodium Hydroxyde',
    'Alcohol',
    'Dextran',
    'Tripeptide-1',
    'Acetyl',
    'Hexapeptide-1',
    'Acetyl Tetrapeptide-2',
    'TrifluoroAcetyl Tripeptide-2'
  ]),
  [PRODUCT_NAMES.NEXULTRA_L]: InciList(null, null, [
    'Aqua (Water)',
    'Zinc Oxide',
    'Titanium Dioxide',
    'C12-15 Alkyl Benzoate',
    'Dimethicone',
    'Propanediol',
    'Camelina Sativa Seed Oil',
    'Polyglyceryl-6 Distearate',
    'Polyhydroxystearic Acid',
    'Potassium Cetyl Phosphate',
    'Lauryl PEG-9 Polydimethylsiloxyethyl Dimethicone',
    'Diisopropyl Sebacate',
    'Propylene Glycol Dicaprylate/Dicaprate',
    'Oleth-10',
    'Diisopropyl Adipate',
    'Aluminum Hydroxide',
    'Sodium Potassium Aluminum Silicate',
    'Jojoba Esters',
    'Glycerin',
    'Hydrogen Dimethicone',
    '1,2-Hexanediol',
    'Pentylene Glycol',
    'Alumina',
    'Aluminum Stearate',
    'Isodeceth-6',
    'Parfum (Fragrance)',
    'Silica',
    'Cetyl Alcohol',
    'Polyglyceryl-3 Beeswax',
    'Chlorphenesin',
    'Citric Acid',
    'Xanthan Gum',
    'CI 77891 (Titanium Dioxide)',
    'Disodium EDTA',
    'Isostearic Acid',
    'Phenoxyethanol',
    'Simethicone',
    'Helianthus Annuus (Sunflower) Seed Oil',
    'Tocopherol',
    'Dextran',
    'Tripeptide-1',
    'Acetyl Hexapeptide-1',
    'TrifluoroAcetyl Tripeptide-2'
  ]),
  [PRODUCT_NAMES.SUNSCREEN_SPF]: InciList(null, null, [
    'Zinc Oxide', 
'Isononyl Isononanoate', 
'Coco Caprylate/Caprate', 
'Dicaprylyl Carbonate', 
'Caprylic/Capric Triglyceride', 
'Titanium Dioxide', 
'Cocos Nucifera (Coconut) Oil', 
'Triethyl Citrate', 
'Polyhydroxystearic Acid', 
'Polyglyceryl-3 Polyricinoleate',
'Iron Oxides (Ci 77492)', 
'Tripeptide-1', 
'Acetyl Hexapeptide-1', 
'Acetyl Tetrapeptide-2', 
'Trifluoroacetyl Tripeptide-2', 
'Camelina Sativa Seed Oil', 
'Tocopherol', 
'Helianthus Annuus (Sunflower) Seed Oil', 
'Glycerin', 
'Dextran',
'Lecithin', 
'Aqua (Water)', 
'Stearic Acid', 
'Isostearic Acid',
'Castor Oil/Ipdi Copolymer', 
'Polyglyceryl-6 Polyricinoleate', 
'Disodium Stearoyl Glutamate', 
'Dilinoleic Acid/Butanediol Copolymer', 
'Alumina', 
'Iron Oxides (Ci 77491, Ci 77499)'
  ]),
  [PRODUCT_NAMES.SUNSCREEN_CRM]: InciList(null, null, [
    'Aqua',
'Zinc Oxide (Nano)',
'Propylene Glycol Diheptanoate',
'C13-15 Alkane',
'Butyloctyl Salicylate',
'Polyglyceryl-3 Polyricinoleate',
'Undecane',
'Propanediol',
'Ethylhexyl Methoxycrylene',
'Niacinamide',
'Disteardimonium Hectorite',
'Tridecane',
'Magnesium Sulfate',
'Tocopheryl Acetate',
'Silica',
'Triethoxycaprylylsilane',
'Phenylpropanol',
'Caprylyl Glycol',
'Sodium Hyaluronate',
'Sodium Phytate',
'Dimethicone',
'Ci 77491',
'Tocopherol',
'Sodium Lauroyl Glutamate',
'Lysine',
'Magnesium Chloride'
  ]),
  [PRODUCT_NAMES.NEXULTRA_UV]: InciList(null, null, [
    'Talc',
    'Titanium Dioxide',
    'Dimethicone',
    'Vinyl Dimethicone/ Methicone Silsesquioxane Crosspolymer',
    'Butyloctyl Salicylate',
    'CI77492 (Iron Oxides)',
    'Stearic Acid',
    'Alumina',
    'CI77491 (Iron Oxides)',
    'Mica',
    'Dimethicone/Vinyl Dimethicone Crosspolymer',
    'CI77499 (Iron Oxides)',
    'Chloprhenesin',
    'Magnesium Aluminum Silicate',
    'Glycerin',
    'Aqua (Water)',
    'Hydroxyethylcellulose',
    'Phospholipids',
    'Acetyl Hexapeptide-1',
    'Dextran'
  ]),
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: InciList(null, null, [
    'Aqua (Water)',
    'Dicaprylyl Carbonate',
    'Propanediol',
    'Camelina Sativa Seed Oil',
    'Glycerin',
    'Cetyl Alcohol',
    'Glyceryl Stearate',
    'Dimethicone',
    'PEG-75 Stearate',
    '1,2-hexanediol',
    'Caprylyl Glycol',
    'Ceteth-20',
    'Steareth-20',
    'Polysilicone-11',
    'Panicum Miliaceum (Millet) Seed Extract',
    'Chlorphenesin',
    'Acrylates/c10-30 Alkyl Acrylate Crosspolymer',
    'Tocopheryl Acetate',
    'Xanthan Gum',
    'Aloe Barbadensis Leaf Juice Powder',
    'Sodium Hydroxide',
    'Citric Acid',
    'Tannic Acid',
    'Potassium Sorbate',
    'Tocopherol',
    'Dextran',
    'Helianthus Annuus (Sunflower) Seed Oil',
    'Tripeptide-1',
    'Acetyl Hexapeptide-1',
    'Acetyl Tetrapeptide-2',
    'Trifluoroacetyl Tripeptide-2'
  ]),
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: InciList(null, null, [
    'Aqua (Water)',
    'Caprylic/Capric Triglyceride',
    'Propanediol',
    'Camelina Sativa Seed Oil',
    'Glycerin',
    'Cetyl Alcohol',
    'Dimethicone',
    'Glyceryl Stearate',
    'Sodium Polyacrylate Starch',
    '1,2-hexanediol',
    'Caprylyl Glycol',
    'PEG-75 Stearate',
    'Chlorphenesin',
    'Xanthan Gum',
    'Ceteth-20',
    'Steareth-20',
    'Tocopheryl Acetate',
    'Helianthus Annuus (sunflower) Seed Oil',
    'Tocopherol',
    'Aloe Barbadensis Leaf Juice Powder',
    'Dextran',
    'Tripeptide-1',
    'Acetyl Hexapeptide-1',
    'Acetyl Tetrapeptide-2',
    'Trifluoroacetyl Tripeptide-2'
  ]),
  [PRODUCT_NAMES.UNIVERSKIN_M]: InciList(null, null, [
    'Aqua (Water)',
    'Propanediol',
    'Helichrysum Italicum Flower Water',
    'Gluconolactone',
    'Tripeptide-1',
    'Acetyl Hexapeptide-1',
    'Trifluoroacetyl Tripeptide-2',
    'Acetyl Tetrapeptide-2',
    'Zanthoxylum Bungeanum Fruit Extract',
    'Polymnia Sonchifolia Root Juice',
    'Leuconostoc/Radish Root Ferment Filtrate',
    'Rhamnose',
    'Calcium Gluconate',
    'Glucose',
    'Glucuronic Acid',
    'Lactobacillus',
    'Dextran',
    'Hydrogenated Palm Glycerides Citrate',
    'Tocopherol',
    'Lauryl Glucoside',
    'Polyglyceryl-6 Laurate',
    'Oleyl Alcohol',
    'Sodium Benzoate',
    'Alpha-Glucan Oligosaccharide',
    'Myristyl Glucoside',
    'Sodium Hydroxide',
    'Glycerin',
    'Maltodextrin'
  ])
};

export {
  SERUM_USAGES,
  PRODUCT_REFERENCES,
  SIZE_MEASUREMENT_UNITS,
  SIZE_MEASUREMENT_UNIT_KEY,
  PRODUCT_NAMES,
  SERUM_PRODUCT_NAMES,
  PRODUCT_SIZE,
  PRODUCT_SIZE_OPTIONS,
  PRODUCTS,
  PRODUCT_USAGE_LABELS_SHORT,
  DEFAULT_TREAT_SECTION_TREATMENT,
  TreatmentDurationConfig,
  EYE_SERUM_GENERIC_FORMULA,
  EYE_SERUM_GENERIC_FORMULA_LABELS,
  EYE_SERUM_GENERIC_FORMULA_DESCRIPTIONS,
  PRODUCT_CATEGORY,
  PRODUCT_CATEGORY_LABEL,
  PRODUCT_NAME_TO_CATEGORIES_LIST_MAP,
  FORMULA_USAGE,
  PRODUCT_REFERENCE_TO_SIZE_MAP,
  COMPLEMENTARY_PRODUCT_INCI_LIST,
  PRODUCT_LABEL
};
